import './sentry';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './pages/auth/login/Login';
import ForgotPassword from './pages/auth/forgotPassword/ForgotPassword';
import ResetPassword from './pages/auth/resetPassword/ResetPassword';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import Company from './modes/Company';
import Individual from './modes/Individual';
import WaterSupplier from './modes/WaterSupplier';
import Admin from './modes/Admin';
import Token from './pages/Token';
import Logout from './pages/Logout';
import Index from './pages/Index';
import HazardSurveyPublicPage from './pages/hazardSurvey/HazardSurveyPublicPage';
import OAuthAuthorize from './pages/oAuth/OAuthAuthorize';
import ErrorFallback from './components/ErrorFallback/ErrorFallback';
import NotifyProvider, { Notification } from './components/NotifyProvider';
import * as Sentry from '@sentry/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'sonner';
export const SentryRoute = Sentry.withSentryRouting(Route);

const Private = () => (
  <Switch>
    <SentryRoute path="/water-supplier" component={WaterSupplier} />
    <SentryRoute path="/company" component={Company} />
    <SentryRoute path="/individual" component={Individual} />
    <SentryRoute path="/admin" component={Admin} />
    <SentryRoute path="/logout" exact component={Logout} />
    <SentryRoute path="/token" exact component={Token} />
    <SentryRoute path="" component={Index} />
  </Switch>
);

export const App: React.FC = () => {
  return (
    <Router>
      <Sentry.ErrorBoundary
        fallback={(errorData) => <ErrorFallback {...errorData} />}
      >
        <GoogleOAuthProvider
          clientId={import.meta.env.ECOS_GOOGLE_CLIENT_ID || ''}
        >
          <NotifyProvider>
            <Switch>
              <SentryRoute path="/login/:authIssuer?" exact component={Login} />
              <SentryRoute
                path="/forgot-password"
                exact
                component={ForgotPassword}
              />
              <SentryRoute
                path="/password-reset/:resetToken?"
                exact
                component={ResetPassword}
              />
              <SentryRoute
                path="/hazard-survey/:token"
                exact
                component={HazardSurveyPublicPage}
              />
              <PrivateRoute
                path="/oauth/authorize"
                exact
                component={OAuthAuthorize}
              />
              <PrivateRoute component={Private} />
            </Switch>
            <Notification />
            <Toaster
              position="top-right"
              visibleToasts={4}
              closeButton
              offset={{ top: 16, right: 16 }}
              swipeDirections={['right']}
            />
          </NotifyProvider>
        </GoogleOAuthProvider>
      </Sentry.ErrorBoundary>
    </Router>
  );
};

export default App;
